export enum MonthlyFee {
    MINIMUM = 'MINIMUM',
    FIXED = 'FIXED',
    PERCENTAGE_NO_MINIMUM = 'PERCENTAGE_NO_MINIMUM',
}